import FormGroup from "@/app/shared/form-group";
import UploadZone from "@/components/ui/file-upload/upload-zone";
import cn from "@/utils/class-names";
import { useFormContext } from "react-hook-form";

export interface MediasPartProps {
  className?: string;
}

export default function MediasPart({ className }: MediasPartProps) {
  const {
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="flex flex-col gap-10">
      <FormGroup description="Accept all type of images" title="Logo">
        <UploadZone
          name="desktopLogo"
          className="col-span-full upload-zone"
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          error={errors?.desktopLogo?.message as string}
          inputProps={{
            multiple: false,
            accept: "image/*",
          }}
        />
      </FormGroup>

      <FormGroup
        title="Thumbnail"
        description="Accept all type of images"
        className={cn(className)}
      >
        <UploadZone
          name="pictures"
          className="col-span-full upload-zone"
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          error={errors?.pictures?.message as string}
          inputProps={{
            multiple: false,
            accept: "image/*",
          }}
        />
      </FormGroup>

      <FormGroup
        title="Gallery"
        description="Accept all type of images and videos"
        className={cn(className)}
      >
        <UploadZone
          name="medias"
          className="col-span-full upload-zone"
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          error={errors?.medias?.message as string}
          inputProps={{
            accept: "image/*,video/*",
            multiple: true,
          }}
        />
      </FormGroup>
    </div>
  );
}
